import React, { useState, useEffect } from 'react';
import { loadScript, PAYMENT_SUCCESS_URL, PAYMENT_FAILURE_URL } from './utils';
import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  InputLeftAddon,
  InputGroup,
  Textarea,
  FormHelperText,
  InputRightElement,
  VStack,
  List,
  ListItem,
  Stack,
  HStack,
  Text,
  Grid,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';
import { Card, CardHeader, CardBody, CardFooter } from '@chakra-ui/react';
import { Divider } from '@chakra-ui/react';
import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import axios from 'axios';

function PaymentComponent() {
  const [promoCode, setPromoCode] = useState('');
  const [promoApplied, setPromoApplied] = useState(false);
  const [price, setPrice] = useState(9.97);
  const toast = useToast();
  const navigate = useNavigate();

  const { state } = useLocation();
  const { orderId } = state;


  useEffect(() => {
    console.log("paymentComp" + orderId)
    loadScript('https://checkout.razorpay.com/v1/checkout.js');
  }, []);

  const handlePromoCodeChange = (event) => {
    setPromoCode(event.target.value);
  };

  const applyPromoCode = () => {
    if (promoCode.trim() !== '') {
      setPromoApplied(true);
      setPrice((prevPrice) => prevPrice - 2);
      console.log('Promo code applied!');

      toast({
        title: 'Promo code applied!',
        description: 'The promo code has been applied successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    }
  };



  const createOrder = () => {


    const options = {
      key: 'rzp_test_nClZSxm0HkJNlS',
      amount: 50000, // Amount in paise (e.g., 50000 paise = ₹500)
      currency: 'INR',
      name: 'Your Company Name',
      description: 'Test Payment',
      image: 'https://yourcompany.com/logo.png',
      order_id: '', // The order ID will be generated on the server-side
      handler: async (response) => {
        // Handle the payment response
        if (response.razorpay_payment_id) {
          // Payment success
          await axios.put('https://glb-api.onrender.com/sop/update/paymentStatus',{ orderId:orderId}, {withCredentials : true});
          window.location.href = PAYMENT_SUCCESS_URL;
        } else {
          // Payment failure or cancel
          window.location.href = PAYMENT_FAILURE_URL;
        }
      },
      prefill: {
        email: 'customer@example.com',
        contact: '9876543210',
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <>
      <Flex minH={'100vh'} align={'center'} justify={'center'}>
        <Stack spacing={8} mx={'auto'} minW={'70%'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'} textAlign={'center'}>
              Confirm order details
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
              Confirm your order details and proceed to payment 📃
            </Text>
          </Stack>
          <Box rounded={'lg'} boxShadow={'lg'} p={8}>
            <VStack alignItems={'left'}>
              <Heading>Service Type</Heading>
              <Text>SOP Review</Text>
            </VStack>
            <Divider />

            <VStack alignItems={'left'}>
              <SimpleGrid
                columns={{ base: 2, md: 2 }}
                spacing={{ base: 20, md: 5 }}
                maxWidth={{ base: '100%', md: '50%' }}
              >
                <List spacing={2}>
                  <ListItem>SOP Type</ListItem>
                  <ListItem>Pages/Words</ListItem>
                  <ListItem>College</ListItem>
                  <ListItem>Language</ListItem>
                  <ListItem>Deadline</ListItem>
                </List>
                <List spacing={2}>
                  <ListItem>Full Review</ListItem>
                  <ListItem>275</ListItem>
                  <ListItem>Atlanta University, USA</ListItem>
                  <ListItem>English</ListItem>
                  <ListItem>02-05-23</ListItem>
                </List>
              </SimpleGrid>
            </VStack>
            <Divider />
            <Box>
              <Grid templateColumns={{ base: '1fr', md: '200px 1fr' }} gap={4} alignItems="center">
                <FormControl>
                  <FormLabel htmlFor="password" fontWeight={'normal'} mt="2%">
                    Apply Promo Code:
                  </FormLabel>
                  <InputGroup size="md">
                    <Input
                      pr="4.5rem"
                      type="text"
                      placeholder="Enter code"
                      value={promoCode}
                      onChange={handlePromoCodeChange}
                      disabled={promoApplied}
                    />
                    <InputRightElement width="4.5rem">
                      <Button size="md" colorScheme="blue" onClick={applyPromoCode} disabled={promoApplied}>
                        Apply
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                </FormControl>
                <Box>
                  <HStack justify={{ base: 'flex-start', md: 'flex-end' }}>
                    <Heading size={'md'}>Estimated price:</Heading>
                    <Text>${price.toFixed(2)}</Text>
                  </HStack>
                </Box>
              </Grid>
            </Box>
          </Box>
          <Box>
            <HStack justify="flex-end">
              <Button
                colorScheme="blue"
                leftIcon={<ArrowBackIcon />}
                variant="outline"
                onClick={() => window.history.back()}
              >
                Back
              </Button>
              <Button colorScheme="blue" rightIcon={<ArrowForwardIcon />} variant="solid" onClick={createOrder}>
                Proceed to Payment
              </Button>
            </HStack>
          </Box>
        </Stack>
      </Flex>
    </>
  );
}

export default PaymentComponent;
